module.exports = __webpack_public_path__ + "static/img/xawysxsfdxjyyey.7a2b9a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/tabs/xawysxsfdxjyyey.png
// module id = X72b
// module chunks = 1